import { paragraphElementType } from "./ParagraphElement.js";
const paragraphHtmlDeserializer = {
  processBlockPaste: ({ element, next, cumulativeTextAttrs }) => element.nodeName === "P" ? {
    type: paragraphElementType,
    children: next(element.childNodes, cumulativeTextAttrs)
  } : null
};
export {
  paragraphHtmlDeserializer
};
//# sourceMappingURL=ParagraphHtmlDeserializer.js.map
